import { useMemo, useState } from 'react';

export const usePlpBodySentinelInitialiser = () => {
  const [plpBodySentinelRef, setPlpBodySentinelRef] = useState(null);

  const returnValue = useMemo(
    () => ({
      plpBodySentinelRef,
      setPlpBodySentinelRef,
    }),
    [plpBodySentinelRef]
  );

  return returnValue;
};
